import React from 'react';
import './assets.css';
import ValueBenefits from './ValueBenefits';

const Assets = ({ onLearnMore }) => {



  return (
    <section className="assets-section">
      <div className="container">
        {/* Assets section content removed - no longer needed */}
      </div>
    </section>
  );
};

export default Assets;
